<template>
    <div class="ConsultHistory">
        <h1>
            <v-icon
                v-if="screen_width > 320"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiClipboardTextClockOutline }}
            </v-icon>
            <span>Request History</span>
        </h1>
        <v-card class="consultHistoryBody">
            <v-card class="hospContainer">
                <v-autocomplete
                    v-model.trim="hosp"
                    color="teal darken-1"
                    :auto-select-first="true"
                    item-text="hosp_name"
                    :loading="loading"
                    :items="hospItems"
                    return-object
                    label="Hospital or Clinic Name"
                />
            </v-card>
            <v-alert
                dense
                outlined
                type="info"
                color="teal darken-4"
                elevation="2"
            >
                Only approvals that are still valid and are requested via HMI Portal are shown.
            </v-alert>
            <v-data-table
                :loading="loading ? 'teal darken-1' : false"
                :headers="headers"
                :items="providerHistory&&providerHistory.data ? providerHistory.data : []"
                class="consultHistoryTbl"
                elevation="1"
                :search="search"
            >
                <template #top>
                    <v-text-field
                        v-model.trim="searchText"
                        :append-icon="mdiMagnify"
                        label="Search"
                        single-line
                        hide-details
                        style="margin: 0 20px 20px 20px;"
                        clearable
                        color="teal darken-1"
                        @click:clear="search = ''"
                        @keydown.enter.prevent="search = searchText"
                        @click:append="search = searchText"
                    />
                </template>
                <template #item="{ item }">
                    <tr>
                        <td>{{ item.OPAN_N }}</td>
                        <td>{{ fetchType(item.TYPE_T) }}</td>
                        <td>{{ item.LAST_M }}</td>
                        <td>{{ item.MEMB_N }}</td>
                        <td>{{ formatDate(item.APPR_D) }}</td>
                        <td>{{ formatDate(item.VALI_D) }}</td>
                        <td>{{ toTitleCase(item.ISSU_N) }}</td>
                        <td>
                            <v-btn
                                small
                                style="background-color: #009688; color: white;"
                                @click="download(item)"
                            >
                                <v-icon>{{ mdiDownload }}</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import { mdiClipboardTextClockOutline, mdiDownload, mdiMagnify } from '@mdi/js'
import { saveAs } from 'file-saver'
import { moment } from '../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
import { base64ToBlob } from '../../../utils/helpers'
export default {
    data: ()=>({
        mdiClipboardTextClockOutline, mdiDownload, mdiMagnify,
        providerId: null,
        searchText: null,
        search: null,
        loading: false,
        hosp: null,
        hospItems: null,
        err: false,
        file: null,
        screen_width: document.documentElement.clientWidth + 9,
        headers: [
            { text: 'APPROVAL NO.', value: 'OPAN_N', class: 'header-class' },
            { text: 'TYPE', value: 'TYPE_T', class: 'header-class' },
            { text: 'NAME', value: 'LAST_M', class: 'header-class' },
            { text: 'HMI ID', value: 'MEMB_N', class: 'header-class' },
            { text: 'APPROVAL DATE', value: 'APPR_D', class: 'header-class' },
            { text: 'VALID UNTIL', value: 'VALI_D', class: 'header-class' },
            { text: 'ISSUER', value: 'ISSU_N', class: 'header-class' },
            { text: 'ACTION' }
        ]
    }),
    computed: {
        ...mapGetters(['providerHistory', 'downloadAuthorization', 'getLinkedProvidersData', 'docInfoData'])
    },
    watch: {
        searchText(newVal) {
            if (newVal === '') {
                this.search = null
            }
        },
        async providerHistory () {
            this.loading = false
        },
        async hosp(newVal) {
            if (newVal) {
                this.loading = true
                await this.getProviderHistory({ PROVIDER_ID: newVal.hosp_msu_code })
            }
        },
        async downloadAuthorization(newVal) {
            newVal && newVal.data && newVal.data.file
                ? await this.fetchFile(newVal.data)
                : this.err = true
        },
        docInfoData(newVal) {
            if (newVal) {
                this.hosp = {
                    hosp_name: newVal.NAME,
                    hosp_msu_code: this.$cookies.get('provider_id')
                }
                if (this.hospItems === null) {
                    this.hospItems = [this.hosp]
                } 
                this.loading = true
                this.getLinkedProviders({ MSU_C: this.providerId })
            }
        },
        getLinkedProvidersData(newVal) {
            if (newVal && newVal.data) {
                this.hospItems = [this.hosp, ...newVal.data]
            }   
            this.loading = false
        }
    },
    created() {
        this.providerId = this.$cookies.get('provider_id')
        this.loading = true
        this.getProviderHistory({ PROVIDER_ID: this.providerId })
        this.getProviderInfo({ PROVIDER_ID: this.providerId })
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['getCsrfToken', 'getProviderHistory', 'downloadApproval', 'getLinkedProviders', 'getProviderInfo']),
        toTitleCase(str) {
            return str.toUpperCase()
        },
        formatDate(date) {
            return moment(date).format('MMM DD, YYYY')
        },
        async download(file) {
            const PROVIDER_ID = this.hosp.hosp_msu_code
            await this.downloadApproval({ PROVIDER_ID, OPAN_N:file.OPAN_N })
            if (!this.err) this.file = file
        },
        async fetchFile(data) {
            return new Promise((resolve, reject) => {
                try {
                    const blob      = base64ToBlob(data.file, data.type)
                    saveAs(blob, `${this.file.OPAN_N}-${moment(this.file.APPR_D).format('YYYY-MM-DD')}.pdf`)
                    resolve()
                } catch (error) {
                    this.error      = 'Something went wrong: ' + error.message
                    reject(new Error(this.error))
                }
            })
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        },
        fetchType(type_t) {
            type_t = String(type_t).trim().toUpperCase()
            switch(type_t) {
            case 'C':
                return 'Consultation'
            case 'O':
                return 'Diagnostic Procedure'
            default:
                return ''
            }
        }
    }
}
</script>

<style>
.ConsultHistory h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.consultHistoryBody {
    margin-top: 5%;
    padding: 3%;
}
    .consultHistoryBody .hospContainer {
        margin-bottom: 15px;
        padding: 15px 15px 2px 15px;
    }
        .consultHistoryBody th {
            text-wrap: nowrap;
            /* background-color: #f0f0f0 !important;
            color: #000 !important;
            font-weight: bold; */
        }/* Freeze last column in tbody */
        .consultHistoryBody div table > tbody > tr > td:last-child,
        .consultHistoryBody div table > thead > tr > th:last-child {
            position: sticky !important;
            position: -webkit-sticky !important;
            right: 0; /* Stick to the right */
            z-index: 2;
            background: white;
        }
        .consultHistoryBody div table > thead > tr > th:last-child {
            z-index: 3;
        }
.ConsultHistory {
    padding: 10px 7.5% 0 7.5%;
}


@media (max-width: 380px) {
  .ConsultHistory {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (max-width: 599px) {
  .ConsultHistory {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 599px) and (max-width: 1264px) {
  .ConsultHistory {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 1264px) {
  .ConsultHistory {
    padding: 10px 7.5% 0 7.5%;
  }
}
</style>
